/**
 * @description Enum with all supported locales
 */
export enum AppLocale {
  KK = 'kk',
  RU = 'ru',
}

export const defaultLocale = AppLocale.RU;
